import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { LocStr, isRoleChecked } from '../utils/Utils';

//=========================================================================

const MySiteAndStudyLine = ( { width, actionsColumnWidth=30, rowIndex, canEdit, theSiteAndStudy, onActionPressed, language } ) => {

    function subjectsDescription(siteItem) 
    {
        let tot = siteItem.siteSubjects.length
        if (tot==0)
        {
            return ''
        } else {
            return '' + tot + ' ' + LocStr('subject/s',language)
        }
    }

    //-----------------------------------------------------

    let subjectsText = subjectsDescription(theSiteAndStudy)

    return (
        <View style={{width:width,height:34,marginTop:0,marginLeft:0}} >

            <View style={{width:width,height:32,marginTop:2,marginLeft:0,borderRadius:5,
                }} >
                
                <TouchableOpacity style={{width:width,height:32,marginTop:0,position:'absolute',flexDirection:'row'}}
                    onPress={() => {onActionPressed('edit',rowIndex);}} disabled={!canEdit}
                    >

                    <View style={{flex:0.3,height:32,justifyContent:'center',backgroundColor:'#fff'}} >

                        <Text numberOfLines={1} ellipsizeMode='tail' style={{
                            //flex:1,
                            marginLeft:8, marginRight:8,
                            textAlign:'left',
                            //alignSelf:'center',
                            fontFamily: "Rubik-Regular",
                            fontSize: 14,
                            color: '#3f3f3f',
                            //backgroundColor:'#0f0',
                            }} >{theSiteAndStudy.siteName}</Text>

                    </View>

                    <View style={{flex:0.7,height:32,justifyContent:'center',backgroundColor:'#fff'}} >

                        <Text numberOfLines={1} ellipsizeMode='tail' style={{
                            //flex:1,
                            marginLeft:8, marginRight:8,
                            textAlign:'left',
                            //alignSelf:'center',
                            fontFamily: "Rubik-Regular",
                            fontSize: 14,
                            color: (theSiteAndStudy.siteStudyId=='no_studies')?'#f00':'#3f3f3f',
                            //backgroundColor:'#0f0',
                            }} >{theSiteAndStudy.siteStudyShortName}</Text>

                    </View>

                    <View style={{width:140,height:32,justifyContent:'center',backgroundColor:'#fff'}} >

                        <Text numberOfLines={1} ellipsizeMode='tail' style={{
                            //flex:1,
                            marginLeft:4, marginRight:4,
                            textAlign:'center',
                            //alignSelf:'center',
                            fontFamily: "Rubik-Regular",
                            fontSize: 14,
                            color: (subjectsText=='')?'#f00':'#3f3f3f',
                            //backgroundColor:'#0f0',
                            }} >{(subjectsText=='')?LocStr('No subjects',language):subjectsText}</Text>

                    </View>

                    <View style={{width:actionsColumnWidth,height:32,flexDirection:'row',backgroundColor:'#fff'}} key={'actions'} >
                    
                        <TouchableOpacity style={{width:30,height:30}} onPress={() => {onActionPressed('edit',rowIndex);}} disabled={!canEdit} >
                            <Feather name="edit-2" style={{fontSize: 16,position: 'absolute',color: canEdit?'#6a707e':'#cfcfcf',marginLeft:8,marginTop:8}} />
                        </TouchableOpacity>

                    </View>
                </TouchableOpacity>
            </View>
        </View>
    );
};

export default MySiteAndStudyLine;